import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import {IStockCheckFields,IDetailList,IStockCheckDetail,IStockCheckSearch,Detailed} from "./stockCheckType"

class StockCheckService {
    async page(searchVo: IStockCheckSearch) {
        const apiUrl = "/vrm-sa/stock/check/findPage";
        return await httpRequest.post<IPage<IStockCheckDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/stock/check/findById/${id}`;
        return await httpRequest.get<IStockCheckDetail>(apiUrl);
    }

    async insert(insertVo: IStockCheckFields) {
        const apiUrl = "/vrm-sa/stock/check/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IStockCheckFields) {
        const apiUrl = "/vrm-sa/stock/check/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //作废
    async invalidate(params:object) {
        const apiUrl = "/vrm-sa/stock/check/invalidate";
        return await httpRequest.post<boolean>(apiUrl,params);
    }
    //盘点完成
    async complete(params:object) {
        const apiUrl = "/vrm-sa/stock/check/complete";
        return await httpRequest.post<boolean>(apiUrl,params);
    }
    //导入盘库
    async warehousing() {
        const apiUrl = "/vrm-sa/stock/check/import";
        return await httpRequest.post<boolean>(apiUrl);
    }
    //明细删除
    async materialDelete(params:Detailed) {
        const apiUrl = "/vrm-sa/stock/check/materialDelete";
        return await httpRequest.post<boolean>(apiUrl,params);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/vrm-sa/stock/check/detail/downloadTpl";
        return await httpRequest.getFile(apiUrl);
    }
    //导出
    async export(searchVo: IStockCheckSearch) {
        const apiUrl = "/vrm-sa/stock/check/export";
        return await httpRequest.postFile(apiUrl, searchVo, { timeout: 600000 });
    }
}

export const stockCheckService = new StockCheckService();